import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import { OffsetScrollListsContext } from 'shared/legacy/contexts/OffsetScrollListsContext';
import { useContextSelector } from 'use-context-selector';
import { useStyles } from './CampaignListInfiniteLoader.styles';
import { useContainer } from './CampaignListInfiniteLoader.useContainer';
import CampaignListItem from './CampaignListItem';

export const CampaignListInfiniteLoader = () => {
  const { campaigns, count, isItemLoaded, loadMoreItems } = useContainer();
  const classes = useStyles();
  const initialOffset = useContextSelector(OffsetScrollListsContext, (state) => state.campaignListOffset);
  const setOffset = useContextSelector(OffsetScrollListsContext, (state) => state.setCampaignListOffset);

  return (
    <AutoSizer>
      {({ height, width }) => (
        <InfiniteLoader isItemLoaded={isItemLoaded} itemCount={count} loadMoreItems={loadMoreItems} threshold={3}>
          {({ ref, onItemsRendered }) => (
            <FixedSizeList
              css={classes.list}
              ref={ref}
              onItemsRendered={onItemsRendered}
              /**
               * '+6' refers to the right padding of its parent. Since there's
               * no way to change FixedSizeList styles (like padding),
               * this is a workaround to correctly position the scrollbar.
               */
              width={width + 6}
              height={height}
              itemCount={count}
              itemSize={60}
              initialScrollOffset={initialOffset}
              onScroll={(e) => setOffset(e.scrollOffset)}
              itemData={campaigns}>
              {CampaignListItem}
            </FixedSizeList>
          )}
        </InfiniteLoader>
      )}
    </AutoSizer>
  );
};
